import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { PixKey } from '../../models/key.model';
import { PixKeyType } from '../../models/key-type.enum';
import { PixMenu } from '../../models/pix-menu.enum';

@Component({
	selector: 'app-pix-keys',
	templateUrl: './list.component.html',
	styleUrls: ['./list.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixKeysComponent implements OnInit {

	constructor(
	) {}

	ngOnInit(): void { }

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	get pixMenu(): typeof PixMenu {
		return PixMenu;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/keys/list/list.component.ts